/**
 * @description трекает клики по статике в header'e
 */
import { analyticService } from 'global/services';

const HeaderLogoNodes = document.querySelectorAll('#global-header-logo-area');
const SighinNodes = document.querySelectorAll('#sighin-wrap');

export const trackHeaderClick = () => {
    if (HeaderLogoNodes.length) {
        HeaderLogoNodes.forEach((node) => node.addEventListener('click', (e) => {
            if (e.target.parentNode.id === 'header-logo-wrap') {
                analyticService.push({ eventName: 'Header_Click', button_name: 'Logo' });
            }
        }));
    }

    if (SighinNodes?.length) {
        SighinNodes.forEach((node) => {
            node.addEventListener('click', () => {
                analyticService.push({ eventName: 'Header_Click', button_name: 'Login' });
            });
        });
    }
};
